import { Route as PatientsRoute } from "@/routes/(pharma)/_layout/patients/index";
import { useQuery } from "@tanstack/react-query";
import { getPatients } from "../-data/api";
import type { Patient } from "@/gen/patients/common_pb";
import {  ListPatientsResponse } from "@/gen/patients/list_patients_pb";

interface PatientQueryResult {
    patients: Patient[];
    totalCount: number;
    page: number;
    pageSize: number;
}

export const usePatientsData = () => {
  const searchParams = PatientsRoute.useSearch();
  
  const page = (searchParams.page || 1);
  const pageSize = searchParams.pageSize || 10;
  
  return useQuery<PatientQueryResult>({
    queryKey: ["patients", searchParams],
    queryFn: async () => {
      const search = searchParams.search || "";

      let response: ListPatientsResponse;
      
      response = await getPatients(page, pageSize, search);

      return {
        patients: response.patients,
        totalCount: response.totalCount,
        page,
        pageSize,
      };
    
    },
    // Keep previous data while fetching new data for better UX
    placeholderData: (previousData) => previousData,
    // Don't refetch when window regains focus
    refetchOnWindowFocus: false,
    // Stale time - how long data stays fresh (5 minutes)
    staleTime: 5 * 60 * 1000,
    // Cache time - how long inactive data stays in cache (10 minutes)
    gcTime: 10 * 60 * 1000,
  });
};
